module.exports = __webpack_public_path__ + "902d3f0a5034bc0ed85253a2f7bcc34c.svg";